import { render, staticRenderFns } from "./formImage.vue?vue&type=template&id=67befcb5&"
import script from "./formImage.vue?vue&type=script&lang=js&"
export * from "./formImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports